module.exports = __webpack_public_path__ + "img/down_40aa5.png";